import { Link } from "react-router-dom";
import "./../styles/news.css";

const AwardPublicity = () => {
  return (
    <div className="news">
      <div className="newsItem">
        <div className="ConetentTitle">
          <h2>
            根据《省科技厅关于2025年度江苏省科学技术奖提名工作的通知》（苏科资发〔2026〕74号）文件要求进行公示
          </h2>

          <div className="ConetentSubTitle">
            根据《省科技厅关于2025年度江苏省科学技术奖提名工作的通知》（苏科资发〔2026〕74号）要求，拟推荐以下项目申报2025年度江苏省科学技术奖并予以公示。
          </div>
        </div>
        <div className="ContentContainer">
          {/* <div className="ContenItem"> */}
          <h3>项目名称 : </h3>
          <p>基于通感控协同的通信机房智能管控关键技术及应用</p>
          {/* </div>
          <div className="ContenItem"> */}
          <h3>申报奖项 : </h3>
          <p>2025年江苏省科学技术奖（科技进步奖）</p>
          {/* </div> */}

          <h3>完成单位 :</h3>
          <p>
            中国联合网络通信有限公司江苏省分公司、南京邮电大学、江苏云网数智信息技术有限公司、南京泰通科技股份有限公司、深圳力维智联技术有限公司
          </p>

          <h3>完成人 :</h3>
          <p>
            孙宏、夏文超、杨福理、周奕昕、徐鼎、孙国意、陈勇君、倪小龙、郭明青
          </p>
        </div>
        <div>
          <Link to="/News" className="newsItemDetail">
            ← 返回新闻列表
          </Link>
        </div>{" "}
      </div>{" "}
    </div>
  );
};

export default AwardPublicity;
